"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFavSorting = exports.getSortingStateRaw = void 0;
const getSortingStateRaw = (state) => state.sorting || {};
exports.getSortingStateRaw = getSortingStateRaw;
const getFavSorting = (state) => (0, exports.getSortingStateRaw)(state).favorites || 'price:asc';
exports.getFavSorting = getFavSorting;
//# sourceMappingURL=sorting.js.map